import "./index.scss";

import { CircularProgress } from "@mui/material";
import React, { FC, memo } from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: any;
  color?: "primary-green" | "primary-blue";
  loading?: boolean;
  disabled?: boolean;
}

const ButtonComponent: FC<ButtonProps> = (props) => {
  const {
    label = "",
    color = "primary-green",
    className,
    disabled = false,
    loading,
    ...restProps
  } = props;

  return (
    <button
      className={`${color}${loading || disabled ? " loading" : ""}${
        className ? ` ${className}` : ""
      }`}
      disabled={disabled || loading}
      {...restProps}
    >
      {loading ? <CircularProgress size={20} disableShrink color="secondary" /> : label}
    </button>
  );
};

const Button = memo(ButtonComponent);
export default Button;
